import { useEffect, useState } from "react";
import { ArrowRight, LockKeyhole } from "lucide-react";
import { api, formatApiError, imgUrl } from "../api";
import Seo from "../components/Seo";
import { useSettings } from "../context/SettingsContext";

export default function ClientPreview() {
  const { settings } = useSettings();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const logo = settings.logo_url ? imgUrl(settings.logo_url) : "/logo.png";

  useEffect(() => {
    api.getOnce("/api/site-launch", { cache: "no-store" })
      .then(({ data }) => {
        if (data?.is_live || data?.preview_authorized) window.location.replace("/");
      })
      .catch(() => {});
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    if (!password.trim()) return setError("Enter the private preview password.");
    setBusy(true);
    setError("");
    try {
      await api.post("/api/site-preview/unlock", { password });
      window.location.replace("/");
    } catch (err) {
      setError(formatApiError(err));
      setBusy(false);
    }
  };

  return (
    <main className="client-preview-page" data-testid="client-preview-page">
      <Seo
        title="Private Client Preview"
        description="Private client preview for the Lalita Soujanya website."
        path="/preview"
        robots="noindex, nofollow, noarchive"
      />
      <section className="client-preview-card">
        <img src={logo} alt={settings.brand_name || "Lalita Soujanya"} className="client-preview-logo" />
        <span className="construction-kicker"><LockKeyhole size={13} /> Private client preview</span>
        <h1>Enter the house.</h1>
        <p>This confidential link lets invited clients review the storefront before its public launch. It does not provide administration access.</p>
        <form onSubmit={submit}>
          <label htmlFor="client-preview-password">Preview password</label>
          <div className="client-preview-input-row">
            <input
              id="client-preview-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              maxLength={128}
              disabled={busy}
              data-testid="client-preview-password"
            />
            <button type="submit" disabled={busy} data-testid="client-preview-submit">
              {busy ? "Opening…" : "Open preview"} <ArrowRight size={15} />
            </button>
          </div>
          {error && <p className="client-preview-error" role="alert">{error}</p>}
        </form>
        <small>Access can be disabled or its password changed at any time by the studio administrator.</small>
      </section>
    </main>
  );
}
